/** Who is on duty: one teammate's Dialpad status, as the strip, rail and socket carry it. */
import {} from '@lsc/domain';
import { z } from 'zod';
export const presenceWord = z.enum(['available', 'busy', 'on_call', 'wrapup', 'unavailable', 'off_duty']);
export const teamMember = z.object({
    email: z.string(),
    name: z.string(),
    department: z.string().nullable(),
    departmentName: z.string().nullable(),
    onDuty: z.boolean(),
    word: presenceWord,
    /** The reason typed when going off duty ("Lunch"). */
    reason: z.string().nullable(),
    /** When the status last changed (ISO). */
    since: z.string(),
});
export const onShiftOutput = z.object({ people: z.array(teamMember), total: z.number().int() });
/** Who holds a ticket: the desk assignee, else the Slack list's Support Team. Empty email: not on the team list. */
export const ticketHolder = z.object({ email: z.string(), name: z.string() });
//# sourceMappingURL=presence.js.map